import { Link, useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { RecoveryShell } from './RecoveryShell'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { getLocaleFromPath, withLocalePath } from '@/lib/i18n-utils'

export function RouteErrorBoundary({ error, reset }: ErrorComponentProps<unknown>) {
  const { t } = useTranslation('pages')
  const locale = getLocaleFromPath(useLocation().pathname)
  useEffect(() => { console.error(JSON.stringify({ event: 'route_render_failed' })) }, [error])
  return <RecoveryShell>
      <h1 className="ledger-serif max-w-[22ch] text-4xl leading-tight md:text-5xl">{t('error.runtime.title')}</h1>
      <p className="ledger-muted mt-6 max-w-[65ch] leading-relaxed">{t('error.runtime.description')}</p>
      <div className="mt-8 flex flex-wrap gap-4">
        <button type="button" className="ledger-button ledger-focus min-h-11" onClick={reset}>{t('error.runtime.retry')}</button>
        <Link className="ledger-button ledger-button--ghost ledger-focus min-h-11" to={withLocalePath('/', locale)}>{t('error.runtime.home')}</Link>
      </div>
  </RecoveryShell>
}
